import React, { useContext, useMemo } from 'react';
import styles from './RecordCompareHeaderCard.module.scss';
import I18n from '../../../../I18n/I18n/I18n';
import { Column } from '../../Layout/RecordCompareLayout';
import { getColumnId } from '../../../util/recordCompareAria';
import RecordCompareStateContext from '../../../RecordCompareStateContext';
export default function HeaderCardColumn(_ref) {
  var index = _ref.index,
    title = _ref.title;
  var _useContext = useContext(RecordCompareStateContext),
    isMergeEnabled = _useContext.isMergeEnabled;
  var i18n = useMemo(function () {
    if (title) {
      return title;
    }
    return {
      id: '@dm/components.record-compare.labels.record-header',
      values: {
        index: index + 1
      }
    };
  }, [index]);
  return /*#__PURE__*/React.createElement(Column, {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.record, " ").concat(isMergeEnabled ? '' : styles.disabled),
    id: getColumnId(index)
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  })));
}